<template>
  <div class="container mt-5">
    <div class="card text-center floating-card">
      <h4 class="floating-content text-danger">Tabla de conteo de registros por persona</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Responsable del Registro</th>
              <th>Total Niños</th>
              <th>Total Mujeres</th>
              <th>Total Registros</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(persona, index) in personasPorResponsable" :key="index">
              <td>{{ persona.responsable }}</td>
              <td>{{ persona.totalNiños }}</td>
              <td>{{ persona.totalMujeres }}</td>
              <td>{{ persona.total }}</td>
            </tr>
            <!-- Agregar una fila para mostrar el total -->
            <tr>
              <td><strong>Total General</strong></td>
              <td>{{ getTotalPorTipo('Niño') }}</td>
              <td>{{ getTotalPorTipo('Mujer') }}</td>
              <td>{{ getTotalGeneral() }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '../store/config';

export default {
  data() {
    return {
      personas: [],
      errorLoadingPersonas: null,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    personasPorResponsable() {
      // Crear un objeto para almacenar el recuento de cada responsable
      const countsByResponsable = {};

      // Llenar countsByResponsable con datos de personas
      this.personas.forEach(persona => {
        const responsable = persona.responsable;

        if (!countsByResponsable[responsable]) {
          countsByResponsable[responsable] = {
            responsable: responsable,
            tipo: '',
            total: 0,
            totalNiños: 0,
            totalMujeres: 0,
          };
        }

        countsByResponsable[responsable].total++;
        
        if (persona.tipo === 'Niño') {
          countsByResponsable[responsable].totalNiños++;
        } else if (persona.tipo === 'Mujer') {
          countsByResponsable[responsable].totalMujeres++;
        }
      });

      // Convertir el objeto countsByResponsable a un array
      return Object.values(countsByResponsable);
    },
  },
  methods: {
    loadPersonas() {
      // Cargar niños
      axios
        .get(`${BASE_URL}/api/nino`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        })
        .then(response => {
          const ninos = response.data.map(persona => ({
            ...persona,
            tipo: 'Niño',
            responsable: `${persona.createdBy.nombre} ${persona.createdBy.apellido}`,
          }));
          this.personas = this.personas.concat(ninos);
        })
        .catch(error => {
          this.errorLoadingPersonas = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
          console.error('Error al cargar niños:', error);
        });

      // Cargar mujeres
      axios
        .get(`${BASE_URL}/api/mujer`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        })
        .then(response => {
          const mujeres = response.data.map(persona => ({
            ...persona,
            tipo: 'Mujer',
            responsable: `${persona.createdBy.nombre} ${persona.createdBy.apellido}`,
          }));
          this.personas = this.personas.concat(mujeres);
        })
        .catch(error => {
          this.errorLoadingPersonas = 'Error al cargar mujeres. Por favor, inténtalo de nuevo.';
          console.error('Error al cargar mujeres:', error);
        });
    },
    getTotalPorTipo(tipo) {
      return this.personas.reduce((total, persona) => {
        if (persona.tipo === tipo) {
          return total + 1;
        }
        return total;
      }, 0);
    },
    getTotalGeneral() {
      return this.personas.length;
    },
  },
  mounted() {
    this.loadPersonas();
  },
};
</script>

<style>
.floating-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  transition: box-shadow 0.3s ease-in-out;
}

.floating-content {
  transform: translate3d(0, -5px, 0);
  transition: transform 0.3s ease-in-out;
}

.grafico {
  margin-left: 80px;
}

.no-underline {
  text-decoration: none;
  color: inherit;
}
</style>
